import React from 'react'
import classNames from 'classnames';
import { useNavigate } from "react-router";
import { ROUTES_PATHS } from 'const';


import styles from './styles/add_or_link_button.module.scss'

const AddOrLinkButton = ({ isAdd, isFetchedAdd, postItem=() => {}, isFullWith = false, className = ''}) => {
  const navigate = useNavigate();

  const handleBuy = () => {
    postItem();
  }

  const handleGoToCart = () => {
    navigate(ROUTES_PATHS.CART);
  }

  const buttonClassNames = classNames({
    [styles.button_add_to_cart]: true,
    [styles['button_add_to_cart--full_with']]: isFullWith,
    [className]: Boolean(className)
  })

  if (isFetchedAdd) {
    return (
      <div
        className={buttonClassNames}
      >

        <div className={styles.button_add_to_cart__loader}>
          <div className={classNames({ [styles.loader__circle]: true, [styles.cart__circle1]: true })}></div>
          <div className={classNames({ [styles.loader__circle]: true, [styles.cart__circle2]: true })}></div>
          <div className={classNames({ [styles.loader__circle]: true, [styles.cart__circle3]: true })}></div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={buttonClassNames}
    >
      {
        isAdd
          ? (
            <button
              type="button"
              className={styles.button_add_to_cart__added}
              onClick={handleGoToCart}
            >
              <span className={styles.button_add_to_cart__icon}></span>
              <span className={styles.button_add_to_cart__title}>
                Перейти в корзину
              </span>
            </button>
          ) : (
            <button
              type="submit"
              className={styles.button_add_to_cart__main}
              onClick={handleBuy}
            >
              <span className={styles.button_add_to_cart__icon}></span>
              <span className={styles.button_add_to_cart__title}>
                Добавить в заказ
              </span>
            </button>
          )
      }
    </div>
  )
}

export default AddOrLinkButton